import * as React from 'react';
import { CSSTransition } from 'react-transition-group';

import { Portal } from '@xing-com/portal';

import { ContentBannerPrimitive } from './content-banner.primitive';
import {
  contentBannerDuration,
  contentBannerTransitionName,
} from './content-banner.styles';
import type { ContentBannerProps } from './content-banner.types';

export const ContentBanner = React.forwardRef<
  HTMLDivElement,
  ContentBannerProps
>(
  (
    {
      children,
      className,
      closeButtonProps,
      display = 'fixed',
      handleOnClose,
      noPadding,
      onExited,
      show = true,
      showCloseButton = true,
      variant = 'default',
      ...props
    },
    forwaredRef
  ): JSX.Element => {
    const timeout = display === 'fixed' ? parseInt(contentBannerDuration) : 0;

    const contentBanner = (
      <ContentBannerPrimitive
        closeButtonProps={closeButtonProps}
        display={display}
        handleOnClose={handleOnClose}
        noPadding={noPadding}
        ref={forwaredRef}
        showCloseButton={showCloseButton}
        variant={variant}
        {...props}
      >
        {children}
      </ContentBannerPrimitive>
    );

    const ContentBannerTransition = (
      <CSSTransition
        appear={show}
        className={className}
        classNames={contentBannerTransitionName}
        in={show}
        key="contentbanner"
        mountOnEnter
        onExited={onExited}
        timeout={timeout}
        unmountOnExit
      >
        {contentBanner}
      </CSSTransition>
    );

    if (display === 'fixed') {
      return <Portal>{ContentBannerTransition}</Portal>;
    }

    return ContentBannerTransition;
  }
);

ContentBanner.displayName = 'ContentBanner';
